import React, { useState } from "react";
import FotorImageUpload from "../components/ImageEnhancer";
import Wrapper from "../components/Wrapper";
import TextArea from "../components/TextArea";

const videoLinks = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/img-enhnc.mp4" },
];

const PhotoEnhancement = () => {
    const [values, setValues] = useState("");

    return (
        <Wrapper
            title={"AI-Powered Enhancements"}
            description={"Our AI instantly enhances low-quality images and generates high-quality content in seconds. "}
            videoLinks={videoLinks}
            body={
                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-8">
                        <FotorImageUpload imageValue={null} onChange={() => { }} />
                    </div>
                    <div className="col-span-4">
                        <TextArea isData={values} setData={setValues} />
                    </div>
                </div>

            }
        />
    );
};

export default PhotoEnhancement;
